import makeApiRequest from '../../../api/makeApiRequest';

const TYPE = 'organization';

const Organization = {
  name: TYPE,
  state: {},
  reducers: {
    onLoaded(state, organization) {
      return {
        ...state,
        ...organization,
      };
    },
  },
  effects: dispatch => ({
    async join(id, { oidcSession }) {
      const [request] = makeApiRequest(
        { url: `/organizations/join/${id}`, method: 'patch' },
        oidcSession,
      );

      const { error, data } = await request;

      if (!error && data) {
        this.onLoaded({
          id: data.data.id,
          ...data.data.attributes,
        });
      } else {
        dispatch.errors.add({ realm: 'organization', type: 'join', error });
      }
    },
  }),
};

export default Organization;
